export const SET_CONTENTS = 'SET_CONTENTS';
export const SET_CONTENT = 'SET_CONTENT';
export const ADD_CONTENT = 'ADD_CONTENT';
export const UPDATE_CONTENT = 'UPDATE_CONTENT';
export const REMOVE_CONTENT = 'REMOVE_CONTENT';
export const CLEAR_CONTENT = 'CLEAR_CONTENT';
export const CLEAR_CONTENTS = 'CLEAR_CONTENTS';
